import { render } from "./cFAQ.vue?vue&type=template&id=6feeaece&scoped=true"
import script from "./cFAQ.vue?vue&type=script&lang=js"
export * from "./cFAQ.vue?vue&type=script&lang=js"

import "./cFAQ.vue?vue&type=style&index=0&id=6feeaece&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6feeaece"]])

export default __exports__